<template>
  <div class="dialog">
    <span class="cls" @click="close"></span>
    <div class="paper">
      <div class="header">
        <h2>버그 리포트</h2>
        <span @click="close"><i class="ph ph-x"></i></span>
      </div>

      <div class="form">
        <div class="field">
          <label>어디서 문제가 발생했나요?</label>
          <input 
            type="text" 
            v-model="form.where" 
            placeholder="예: 고객 등록 화면, 메인 대시보드..."
          />
        </div>

        <div class="field">
          <label>어떤 문제인가요?</label>
          <textarea 
            v-model="form.description" 
            placeholder="문제 상황을 간략히 설명해 주세요..."
            rows="5"
          ></textarea>
        </div>
      </div>

      <div class="footer">
        <button class="btn-cancel" @click="close">취소</button>
        <button class="btn-submit" @click="submit" :disabled="!canSubmit">
          <i :class="isSubmitting ? 'ph ph-spinner' : 'ph ph-paper-plane-tilt'"></i>
          {{ isSubmitting ? '제출 중...' : '제출하기' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, inject } from "vue"

export default {
  props: {
    oth_showBugReport: Function
  },
  setup(props) {
    const sql_query = inject("sql_query")
    const member_info = inject("member_info")
    
    const form = ref({
      where: '',
      description: ''
    })
    
    const isSubmitting = ref(false)

    const canSubmit = computed(() => {
      return form.value.where.trim() && form.value.description.trim() && !isSubmitting.value
    })

    const close = () => {
      props.oth_showBugReport(false)
    }

    const submit = async () => {
      if (!canSubmit.value) return
      
      isSubmitting.value = true

      try {
        const where = form.value.where.replace(/'/g, "''")
        const desc = form.value.description.replace(/'/g, "''")
        
        await sql_query(`
          INSERT INTO bug_report (mb_id, location, description) 
          VALUES ('${member_info.mb_id}', '${where}', '${desc}')
        `)
        
        alert('버그 리포트가 제출되었습니다. 감사합니다!')
        close()
      } catch (e) {
        console.error(e)
        alert('제출 중 오류가 발생했습니다.')
      } finally {
        isSubmitting.value = false
      }
    }

    return {
      form,
      canSubmit,
      close,
      submit,
      isSubmitting
    }
  }
}
</script>

<style scoped>
.dialog {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  backdrop-filter: blur(2px);
}

.dialog > .cls {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

.dialog > .paper {
  width: 90%;
  max-width: 500px;
  background: var(--color-background);
  border: 1px solid var(--color-background-light);
  border-radius: 16px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.paper > .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.paper > .header > h2 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin: 0;
}

.paper > .header > span {
  width: var(--font-size-3xl);
  height: var(--font-size-3xl);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.paper > .header > span > i {
  font-size: var(--font-size-xl);
  color: var(--color-text-primary);
}

.form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field > label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-secondary);
}

.field > input,
.field > textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid var(--color-background-light);
  border-radius: 8px;
  background: var(--color-surface);
  color: var(--color-text-primary);
  font-size: var(--font-size-base);
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.2s;
}

.field > input:focus,
.field > textarea:focus {
  border-color: var(--color-primary);
}

.field > textarea {
  resize: vertical;
  min-height: 100px;
}

.footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn-cancel {
  padding: 10px 20px;
  border: 1px solid var(--color-background-light);
  border-radius: 8px;
  background: transparent;
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: background 0.2s;
}

.btn-cancel:hover {
  background: var(--color-surface);
}

.btn-submit {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  background: var(--color-brand);
  color: white;
  font-size: var(--font-size-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: opacity 0.2s;
}

.btn-submit:hover {
  opacity: 0.9;
}

.btn-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>